/** Doc-type whitelist for the collab service. Future modules add their type here. */
export const COLLAB_DOC_TYPES = [
    "solve_canvas",
    "hoshin_canvas",
    "vsm_canvas",
];
/**
 * Redis channel playbook-be publishes to (and every collab pod subscribes
 * to) when a lock or Facilitator fact changes at REST. Best-effort,
 * post-commit: enforcement never depends on delivery (the REST gates are
 * authoritative; a missed message only delays the live socket flip until
 * reconnect/cache expiry).
 */
export const COLLAB_REAUTH_CHANNEL = "pb:collab:reauth";
/** Application-owned board-status fanout; deliberately compile-time, not Helm config. */
export const COLLAB_BOARD_STATUS_CHANNEL = "pb:collab:board-status:v1";
export const COLLAB_MAX_ENCODED_BYTES = 5_242_880;
export const VSM_SIZE_READ_ONLY_BYTES = 4_194_304;
export const VSM_LIVE_TAB_WARNING_COUNT = 20;
//# sourceMappingURL=collab.js.map